import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import { get } from 'helpers/api';
import { debounce, isEmpty } from 'lodash';
import { Button, Modal } from 'react-bootstrap-5';

import BrokersList from './brokers_list';
import ErrorAlert from './error_alert';

const Option = (props) => {
  return (
    <components.Option {...props}>
      <div>
        <strong>{props.data.label}</strong>
      </div>
      {props.data.source && <small>Source: {props.data.source}</small>}
    </components.Option>
  );
};
Option.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired
  }).isRequired
};

export default function NewPropertyFromExisting({
  edgeCrmAccess,
  errorMessages,
  gotoPrevStep,
  hasErrors,
  maxBrokersLimit,
  saving,
  showBrokerSelect,
  onSave
}) {
  const [researchPropertyId, setResearchPropertyId] = useState();
  const [brokers, setBrokers] = useState([{}]);

  const searchResearchProperties = (inputValue, callback) => {
    const params = { allDatabases: true, 'q[name_or_address_cont]': inputValue };

    get('/research/properties', { params }).then((data) => {
      const foundProperties = data.properties.map(property => ({
        label: property.address,
        value: property.id,
        source: edgeCrmAccess ? null : property.databaseName,
      }));
      callback(foundProperties);
    });
  };

  const save = () => {
    const newListing = { researchPropertyId, brokerIds: brokers.map(broker => broker.value || {}) };
    if (edgeCrmAccess) {
      newListing.edgeResearchPropertyId = researchPropertyId;
    }
    onSave(newListing);
  };

  const saveButtonDisabled = saving
    || !researchPropertyId
    || (showBrokerSelect && brokers.some(item => isEmpty(item)));

  return (
    <div>
      <Modal.Body className="py-10 px-8">
        <h6 className="fw-bold mt-0 mb-5 text-center">Create from an existing property</h6>
        <ErrorAlert errorMessages={errorMessages} hasErrors={hasErrors} />
        <div className="mb-4">
          <label className="fw-semibold mb-1">Select an existing property</label>
          <AsyncSelect
            classNamePrefix="react-select"
            components={{ Option }}
            loadOptions={debounce(searchResearchProperties, 300)}
            menuPortalTarget={document.body}
            placeholder={'Search by name'}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            onChange={({ value }) => {
              setResearchPropertyId(value);
            }}
          />
        </div>

        {researchPropertyId && showBrokerSelect && (
          <div className="mb-4">
            <BrokersList
              brokers={brokers}
              maxBrokersLimit={maxBrokersLimit}
              onSetBrokers={setBrokers}
            />
          </div>
        )}

        <div className="mt-6 d-flex justify-content-end gap-3">
          {gotoPrevStep && (
            <Button variant="ghost" onClick={gotoPrevStep}>Back</Button>
          )}
          <Button disabled={saveButtonDisabled} name="save" variant="primary" onClick={save}>
            {saving ? 'Saving ...' : 'Create new listing'}
          </Button>
        </div>
      </Modal.Body>
    </div>
  );
}

NewPropertyFromExisting.propTypes = {
  edgeCrmAccess: PropTypes.bool,
  errorMessages: PropTypes.object,
  gotoPrevStep: PropTypes.func,
  hasErrors: PropTypes.bool.isRequired,
  maxBrokersLimit: PropTypes.number.isRequired,
  saving: PropTypes.bool.isRequired,
  showBrokerSelect: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired
};
